module.exports = __webpack_public_path__ + "static/media/header.ca272048.png";